import {axiosInstance} from './axios';

export async function getStudentsApi() {
  try {
    return await axiosInstance.get('/api/v1/students');
  } catch (e) {
    return null;
  }
}
export async function getSemesterApi() {
  try {
    return await axiosInstance.get('/api/v1/semester');
  } catch (e) {
    return null;
  }
}

export async function addStudentApi(data) {
  try {
    return await axiosInstance.post('/api/v1/students', data,
    {headers:{
      user:"admin",
      university: localStorage.getItem("uni")
    }});
  } catch (e) {
    return {err:e};
  }
}
export async function addSemesterApi(data) {
  try {
    return await axiosInstance.post('/api/v1/semester', data);
  } catch (e) {
    return null;
  }
}

export async function getSemesterByIdApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/semester/${id}`);
  } catch (e) {
    return null;
  }
}

export async function assignTrip(data) {
  try {
    return await axiosInstance.post('/api/v1/students/assign-travel-bulk', data);
  } catch (e) {
    return null;
  }
}

export async function getStudentApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/students/${id}`);
  } catch (e) {
    return null;
  }
}
export async function getStudentTripApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/students/my-trip/${id}`);
  } catch (e) {
    return null;
  }
}
export async function getAssignTrip(id) {
  try {
    return await axiosInstance.get(`/api/v1/students/assign-travel/${id}`);
  } catch (e) {
    return null;
  }
}

export async function editStudentApi(data, id) {
  try {
    return await axiosInstance.put(`/api/v1/students/${id}`, data);
  } catch (e) {
    return null;
  }
}
export async function bulkUpdate(data) {
  try {
    return await axiosInstance.put(`/api/v1/import/students/bulk-edit`, data);
  } catch (e) {
    return null;
  }
}
export async function editSemesterApi(data, id) {
  try {
    return await axiosInstance.put(`/api/v1/semester/${id}`, data);
  } catch (e) {
    return null;
  }
}

export async function removeStudentApi(id) {
  try {
    return await axiosInstance.delete(`/api/v1/students/${id}`);
  } catch (e) {
    return null;
  }
}
export async function canclledStudentTravel(id) {
  try {
    return await axiosInstance.delete(`/api/v1/students/assign-travel/${id}`);
  } catch (e) {
    return null;
  }
}
export async function removeSemesterApi(id) {
  try {
    return await axiosInstance.delete(`/api/v1/semester/${id}`);
  } catch (e) {
    return null;
  }
}
